import React from "react";
import { Field, formValueSelector, reduxForm } from "redux-form";
import validate from "./validate";
import AccountOutlineIcon from "mdi-react/AccountOutlineIcon";
import { CPF } from "components/NumberFormat";
import { Spinner } from "reactstrap";
import { useSelector } from "react-redux";

const FormOne = props => {
	const {
		handleSubmit,
		pristine,
		submitting,
		previousPage,
		onFormOneSubmit
	} = props;

	const state = useSelector(state => state);

	const selector = formValueSelector("certificate_emission");

	const loading = selector(state, "loading");

	const handleNextClick = e => {
		e.preventDefault();
		handleSubmit(onFormOneSubmit);
	};

	return (
		<form className="form" onSubmit={handleNextClick}>
			<div className="form__form-group">
				<span className="form__form-group-label">CPF</span>
				<div className="form__form-group-field">
					<div className="form__form-group-icon">
						<AccountOutlineIcon />
					</div>
					<Field
						name="document"
						component={CPF}
						type="text"
						placeholder="Seu CPF"
					/>
				</div>
			</div>

			<div className="account__btn__group">
				<button
					type="button"
					className="btn btn-primary account__btn account__btn--small"
					onClick={previousPage}
				>
					Voltar
				</button>
				<button
					type="submit"
					className="btn btn-primary account__btn account__btn--small"
					disabled={pristine || submitting}
				>
					{loading ? <Spinner type="grow" size="sm" color="dark" /> : "Próximo"}
				</button>
			</div>
		</form>
	);
};

export default reduxForm({
	form: "certificate_emission",
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate: v => validate(v, 1)
})(FormOne);
